// extracted by mini-css-extract-plugin
export default {"root":"KryQ95DZ","icon":"claTEEDw","amount":"jvqdflj6","amountSecondary":"g5Cns47k","value":"hjJEeCr1","change":"NY7VPhFn","positive":"RRbNG6Ih","negative":"Ojy0oKtS"};